import { render } from "./ClawView.vue?vue&type=template&id=a62f2b08"
import script from "./ClawView.vue?vue&type=script&lang=js"
export * from "./ClawView.vue?vue&type=script&lang=js"

import "./ClawView.vue?vue&type=style&index=0&id=a62f2b08&lang=css"

import exportComponent from "/Users/peterdevos/Sites/clawmachine_yardi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__